import { useAuth } from '../../shared/context';
import { AuthState } from '../../shared/enum';
import { ChangeTemporaryPassword, MfaCode, SignIn } from './components';

export const Login = () => {
  const auth = useAuth();

  if (auth.state === AuthState.Challenge) {
    if (auth.challengeName === 'NEW_PASSWORD_REQUIRED') {
      return (
        <ChangeTemporaryPassword
          email={auth.cognitoUser.challengeParam?.userAttributes.email!}
        />
      );
    }

    return <MfaCode mfaType={auth.challengeName} />;
  }

  return <SignIn />;
};
